module.exports = {"220871001":"幸福街道","220871002":"保平街道","220871003":"西郊街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220871.json
// module id = 750
// module chunks = 0